<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
    <div class="min-h-screen bg-gray-50 p-8">
      <!-- 头部区域 -->
      <div class="flex justify-between items-center mb-8">
        <h1 class="text-2xl font-bold text-gray-800">概况数据</h1>
        <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <button 
              v-for="period in timePeriods" 
              :key="period.value"
              @click="currentPeriod = period.value"
              :class="[
                'px-4 py-2 text-sm !rounded-button whitespace-nowrap',
                currentPeriod === period.value 
                  ? 'bg-blue-600 text-white' 
                  : 'bg-white text-gray-600 border border-gray-200'
              ]"
            >
              {{ period.label }}
            </button>
          </div>

 
          <div class="relative" v-if="currentPeriod == 'all'">
          <!-- 日期范围选择 -->
          <div class="flex items-center gap-2">
          <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
            <span class="text-gray-500">至</span>
            <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
            </div>
        

            </div>

            <button @click="search" class="!rounded-button flex items-center px-4 py-2 bg-blue-600 text-white hover:bg-blue-700" style="width: 60px;height: 36px;margin-left: 20px;">
                    查询
            </button>
          
        </div>
      </div>
  
      <!-- 数据卡片区域 -->
      <div class="grid grid-cols-3 gap-6 mb-8">
        <div v-for="(card, index) in dataCards" :key="index" 
          class="bg-white rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <span class="text-gray-600">{{ card.title }}</span>
            <i :class="['fas', card.icon, 'text-blue-500 text-xl']"></i>
          </div>
          <div class="flex items-end space-x-4">
            <span class="text-3xl font-bold text-gray-800">{{ card.value }}</span>
            <div class="flex items-center space-x-2">
              <span :class="[
                'text-sm',
                card.trend > 0 ? 'text-green-500' : 'text-red-500'
              ]">
                <i :class="[
                  'fas',
                  card.trend > 0 ? 'fa-arrow-up' : 'fa-arrow-down'
                ]"></i>
                {{ Math.abs(card.trend) }}%
              </span>
              <span class="text-gray-400 text-sm">同比</span>
            </div>
          </div>
        </div>
      </div>
  
      <!-- 表格区域 -->
      <div class="bg-white rounded-lg shadow-sm">
        <div class="p-6 border-b border-gray-100 flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-800">推荐信息列表</h2>
          <button @click="exportExcel" class="bg-blue-600 text-white px-6 py-2 flex items-center space-x-2 !rounded-button whitespace-nowrap">
            <i class="fas fa-download"></i>
            <span>导出数据</span>
          </button>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full">
            <thead class="bg-gray-50">
              <tr>
                <th v-for="header in tableHeaders" :key="header.key"
                  class="px-6 py-4 text-left text-sm font-medium text-gray-600">
                  {{ header.label }}
                </th> 
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in orders" :key="index"
                class="border-t border-gray-100">
                <td class="px-6 py-4">
                  <div class="flex items-center space-x-3">
                    <img :src="row.avatarUrl" class="w-8 h-8 rounded-full object-cover"/>
                    <div>
                      <div class="font-medium text-gray-800">{{ row.nickName }}</div>
                      <div class="text-sm text-gray-500">ID: {{ row.user_id }}</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 text-gray-600">{{ row.grade.name }}</td>
                <td class="px-6 py-4 text-gray-600">{{ row.recommendCount }}</td>
                <td class="px-6 py-4 text-gray-600">{{ row.create_time }}</td>
                
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                background :current-page="curPage"
                :page-sizes="[20, 100,500, 1000]"
                layout="total,sizes, prev, pager, next, jumper"
                :total="totalDataNumber"></el-pagination>
            </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import StatisticsApi from '@/api/statistics.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        currentPeriod: 'all',
        showDatePicker: false,
        dateRange: '2024-01-01 - 2024-01-31',
        timePeriods: [
          { label: '今日', value: 'today' },
          { label: '本月', value: 'month' },
          { label: '今年', value: 'year' },
          { label: '全部', value: 'all' }
        ],
        dataCards: [
          {
            title: '新增VIP会员',
            value: '2,846',
            trend: 12.5,
            icon: 'fa-crown'
          },
          {
            title: '新增科普中心',
            value: '186',
            trend: -5.2,
            icon: 'fa-building'
          },
          {
            title: '新增运营中心',
            value: '92',
            trend: 8.3,
            icon: 'fa-chart-line'
          }
        ],
        tableHeaders: [
          { key: 'user', label: '推荐人信息' },
          { key: 'grade', label: '身份' },
          { key: 'count', label: 'VIP会员数' },
          { key: 'create_time', label: '注册时间' },
        ],
        tableData: [
        ],
        currentPage: 1,
        total: 256,


        orders: [
        ],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {
            customerName: '',
            status: '',
            category: '',
            dateRange: '',
            startDate: '',
            endDate: '',
        },
      };
    },
    mounted() {
    var self = this;
    self.search()
  },
  methods: {
    exportExcel() {
      var parmasa =  this.form?this.form:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage 
      parmasa['currentPeriod'] = this.currentPeriod
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/product.product/exportCaiwu?' + 
      qs.stringify(parmasa);
        
    },
    search(){
        this.getOrderLists();
        this.getNewMemberCards();
    },
    getNewMemberCards(){
      let self = this;
      let Params = self.form
        Params.page = self.curPage
        Params.list_rows = self.pageSize
        Params.currentPeriod = self.currentPeriod
        StatisticsApi.getNewMemberCards(Params, true)
        .then(res => {
            self.dataCards = res.data.dataCards;


        })
        .catch(error => {});
    },
    getOrderLists(){
      let self = this;
      let Params = self.form
        Params.page = self.curPage
        Params.list_rows = self.pageSize
        Params.currentPeriod = self.currentPeriod
        StatisticsApi.getFirstLevelReferees(Params, true)
        .then(res => {
            self.orders = res.data.list.data;
            self.totalDataNumber = res.data.list.total;

        })
        .catch(error => {});
    },
             /*选择第几页*/
             handleCurrentChange(val) {
            this.curPage = val
            this.getOrderLists()
            },
            /*每页多少条*/
            handleSizeChange(val) {
            this.curPage = 1
            this.pageSize = val
            this.getOrderLists()
        },  




  }
  };
  </script>
  
  <style scoped>
  .table-wrapper::-webkit-scrollbar {
    height: 6px;
  }
  
  .table-wrapper::-webkit-scrollbar-thumb {
    background-color: #cbd5e0;
    border-radius: 3px;
  }
  
  .table-wrapper::-webkit-scrollbar-track {
    background-color: #f7fafc;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/statistics/gaikuang.vue